/* eslint-disable import/no-anonymous-default-export */
import {
  TOGGLE_NAV_DRAWER,
  TOGGLE_SHOW_HEADER_FOOTER,
  CHANGE_ACTIVE_NAV_BOX_ITEM,
  LOADING_SHAHRZAD,
} from "../actionTypes/layout";

const localStorageData = JSON.parse(sessionStorage.getItem("Layout")) || {};
const initialState = {
  isNavDrawerOpen: false,
  showHeaderFooter: true,
  navBoxActiveItem: 0,
  loadingShahrzad: false,
  ...localStorageData,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_NAV_DRAWER:
      return {
        ...state,
        isNavDrawerOpen: !state.isNavDrawerOpen,
      };
    case TOGGLE_SHOW_HEADER_FOOTER:
      sessionStorage.setItem(
        "Layout",
        JSON.stringify({ ...state, showHeaderFooter: !state.showHeaderFooter })
      );
      return {
        ...state,
        showHeaderFooter: !state.showHeaderFooter,
      };
    case LOADING_SHAHRZAD:
      const { showShahrzad } = action;
      return {
        ...state,
        loadingShahrzad: showShahrzad,
      };
    case CHANGE_ACTIVE_NAV_BOX_ITEM:
      const { data } = action;
      sessionStorage.setItem(
        "Layout",
        JSON.stringify({ ...state, navBoxActiveItem: data })
      );
      return {
        ...state,
        navBoxActiveItem: data,
      };

    default:
      return state;
  }
}
